import { render, staticRenderFns } from "./DashboardProductLink.vue?vue&type=template&id=5e42acdc&scoped=true&"
import script from "./DashboardProductLink.vue?vue&type=script&lang=js&"
export * from "./DashboardProductLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e42acdc",
  null
  
)

export default component.exports